import Vue from "vue";
import Component from 'vue-class-component';
import { modalHelper, IModalBase, DataItem, alertHelper } from '@/components';
import { Deferred } from '@/utils/Deferred';
import { areaSaggioStore } from '../store/areaSaggio.store';
import { Prop } from 'vue-property-decorator';
import map from "./map.vue";
import { Async } from '@/utils/AsyncDecorators';
import { areaRaccoltaStore } from '@/modules/AreaRaccolta/store/areaRaccolta.store';
import { localizeFunction } from '@/filters/localizeFilter';
import { toastHelper } from '@/helpers/ToastHelper';
import { domainStore } from '@/modules/domains/store/domains.store';
import { Esri } from '@/esriMap';
import { arcgisToGeoJSON, geojsonToArcGIS } from "@esri/arcgis-to-geojson-utils";
import { onlineCheck } from "@/utils/onlineCheck";
@Component({})
export default class Form extends Vue implements IModalBase<server.areaSaggio>{
  @Prop()
  value: server.areaSaggio;

  @Prop()
  deferred: Deferred<DataItem<server.areaSaggio>>;

  @Async({ async get() { return (await areaRaccoltaStore.getters.getAll()).sort((a, b) => a.nome.localeCompare(b.nome)); }, default: [], lazy: true })
  areeRaccolta: server.areaRaccolta[];

  @Async({ async get() { return await domainStore.getters.specieArboree(); }, default: [], lazy: true })
  specieArboree: domains.domini[];

  mounted() {
    setTimeout(this.validateForm, 2000);
  }

  formIsValid: boolean = false;
  validateForm() {
    this.formIsValid = (this.$refs.form && (this.$refs.form as any).checkValidity())
  }

  provaslider: number = 20;
  cancel() {
    modalHelper.Unchanged(this);
    modalHelper.closeModal("extended");
  }

  saving: boolean = false;
  async ok() {
    if (this.saving) return;
    if (this.value.speciePresenti.length == 0) {
      toastHelper.error('Inserire almeno una specie arborea tra le specie presenti');
      return
    }
    this.saving = true;
    await areaSaggioStore.actions.setAreaSaggio(this.value);
    await (this.$refs.slideShow as any).save(this.value.id);
    modalHelper.Changed(this);
  }


  async remove() {
    const beforeDelete = await this.beforeDelete(this.value.id);
    if (beforeDelete)
      if (await alertHelper.show(localizeFunction('confirm-delete', `Sei sicuro di voler cancellare l'elemento corrente?`))) {
        try {
          await areaSaggioStore.actions.remove(this.value);
          modalHelper.Deleted(this);
        } catch (e) {
          if (e && e.response && e.response.status == 412) toastHelper.error('Impossibile cancellare elemento, sono presenti uno o più vincoli che ne impediscono la cancellazione.')
          modalHelper.Unchanged(this);
        }

      } else {
        modalHelper.Unchanged(this);
      }
  }

  async beforeDelete(areaSaggioId: string) {
    const needSync = await areaSaggioStore.getters.requiredSync(areaSaggioId);
    if (needSync) {
      toastHelper.error("Ci sono delle aree di saggio che necessitano di sincronia. Effettuare la sincronia prima di poter effettuare la cancellazione")
      return false;
    }

    const online = onlineCheck()
    if (!online) {
      toastHelper.error("Non è possibile effettuare la cancellazione in modalità Offline")
      return false;
    }

    return !needSync && online;
  }

  async editGeometry() {
    const result: DataItem<server.areaSaggio> = await modalHelper.showModal<server.areaSaggio>(map, Object.assign({}, this.value), "extended");
    if (result.status && result.item.geoJSON) {
      this.value.geoJSON = result.item.geoJSON;
      this.value.area = result.item.area;
      this.value.raggio = parseFloat(result.item.raggio.toFixed(2));
    }
  }

  async geoJsonUploaderChange(geoJSON: string) {
    const geoEngine = await Esri.Geometry.geometryEngine();
    const geoUtils = await Esri.Geometry.Support.webMercatorUtils();
    let pointConstructor: __esri.PointConstructor = await Esri.Geometry.PointConstructor();
    let point = new pointConstructor(geojsonToArcGIS(geoJSON));
    point = geoUtils.geographicToWebMercator(point) as any;

    let circle = geoEngine.geodesicBuffer(point, this.value.raggio || 20, "meters") as __esri.Polygon;
    let geographicGeometry = geoUtils.webMercatorToGeographic(circle)
    this.value.geoJSON = arcgisToGeoJSON(geographicGeometry);

    this.editGeometry();
  }
}